import type { UUID } from '@/utils/uuid';

export const permissionQueryKeys = {
  myPermissions: (tenantId?: UUID) => ['my-permissions', tenantId] as const,
};
